module.exports = __webpack_public_path__ + "img/maj6.39eb6ed1.jpg";